<template>
  <div ref="messageRef" v-show="showMessage" :class="baseClass" role="alert">
    <div class="alert-body">
      <slot><span v-html="messageBody"></span></slot>
    </div>
    <button type="button" class="btn-close" v-if="props.showClose" @click="$emit('hideAlert')"></button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, defineExpose, ref, inject } from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

const dayJS = inject('dayJS');
dayjs.extend(duration);

const messageBody = ref('');
const showMessage = ref(false);
const variant = ref('alert-danger');

const props = defineProps({
  showClose: {
    type: Boolean,
    default: false,
  },
  marginTop: {
    type: Number,
    default: 2,
  },
  positionFixe: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['hideAlert']);

const marginTopClass = computed({
  get: () => (props.marginTop >= 0 ? `mt-${props.marginTop}` : 'mt-2'),
});

const basePositionFixe = computed({
  get: () => (props.positionFixe ? 'position-fixed sticky-top end-0 px-1 me-2 w-50 text-start' : ''),
});

const baseClass = computed({
  get() {
    return [
      'alert',
      'alert-dismissible',
      'fade',
      'show',
      marginTopClass.value,
      variant.value,
      basePositionFixe.value,
    ];
  },
});

function setMessageBody(message, variantClass = 'danger', timeoutSecond = 0) {
  messageBody.value = message;
  showMessage.value = true;
  variant.value = variantClass ? `alert-${variantClass}` : 'alert-danger';
  if (timeoutSecond && timeoutSecond > 0) {
    setTimeout(() => {
      showMessage.value = false;
    }, dayJS.duration({ second: timeoutSecond }).asMilliseconds());
  }
}

function hideMessage() {
  showMessage.value = false;
}

defineExpose({
  setMessageBody,
  hideMessage,
});
</script>
